const ACCESS_TOKEN = "access_token";
const DISPLAY_NOTIFICATION = "display_notification";
const GLOBAL_NOTIFICATION = "global_notification";

const setToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

const getToken = () => {
  return localStorage.getItem(ACCESS_TOKEN);
};

const eraseToken = () => {
  localStorage.removeItem(ACCESS_TOKEN);
};

const setDisplayNotification = () => {
  localStorage.setItem(DISPLAY_NOTIFICATION, "true");
};

const getDisplayNotification = () => {
  return localStorage.getItem(DISPLAY_NOTIFICATION);
};

const setGlobalNotification = ({ message, variant, persist = true }) => {
  localStorage.setItem(
    GLOBAL_NOTIFICATION,
    JSON.stringify({ message, variant, persist })
  );
};

const getGlobalNotification = () => {
  const globalNotification = localStorage.getItem(GLOBAL_NOTIFICATION);
  if (!globalNotification) return null;

  const parsedGlobalNotification = JSON.parse(globalNotification);

  if (
    parsedGlobalNotification.message &&
    parsedGlobalNotification.variant &&
    parsedGlobalNotification.persist
  ) {
    return parsedGlobalNotification;
  }

  return null;
};

const eraseGlobalNotification = () => {
  localStorage.removeItem(GLOBAL_NOTIFICATION);
};

const eraseDisplayNotification = () => {
  localStorage.removeItem(DISPLAY_NOTIFICATION);
};

export {
  setToken,
  getToken,
  eraseToken,
  setDisplayNotification,
  getDisplayNotification,
  eraseDisplayNotification,
  getGlobalNotification,
  setGlobalNotification,
  eraseGlobalNotification
};
